import {NgModule} from '@angular/core';
import {InsolesUserSummaryConverter} from './api/model/user/insolesUserSummary.converter';
import {InsolesPatientSummaryConverter} from './api/model/patient/insolesPatientSummary.converter';
import {InsolesCustomerAccountSummaryConverter} from './api/model/customer/insolesCustomerAccountSummary.converter';
import {InsolesCamProfileConverter} from './api/model/cam/insolesCamProfile.converter';
import {InsolesTypeSummaryConverter} from './api/model/type/common/insolesTypeSummary.converter';
import {InsolesSummaryConverter} from './api/model/insolesSummary.converter';
import {InsolesConverter} from './api/model/insoles.converter';
import {InsolesRepository} from './impl/service/ngrx/insoles.repository';
import {InsolesDataService} from './impl/service/ngrx/insoles.data.service';
import {InsolesDataServiceAdapter} from './impl/service/ngrx/insoles.data.service.adapter';
import {InsolesSummaryDataServiceAdapter} from './impl/service/ngrx/insolesSummary.data.service.adapter';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {InsolesTypeFamilySummaryConverter} from './api/model/type/family/insolesTypeFamilySummary.converter';
import {errorMessages} from "../../core/error/errorMessages";
import {ProviderModule} from "../../provider/provider.module";
import {Scan3dModule} from "../scan3d/scan3d.module";
import {Scanner3dModule} from "../scanner3d/scanner3d.module";

@NgModule({
    providers: [
        InsolesUserSummaryConverter,
        InsolesPatientSummaryConverter,
        InsolesCustomerAccountSummaryConverter,
        InsolesCamProfileConverter,
        InsolesCustomerAccountSummaryConverter,
        InsolesTypeSummaryConverter,
        InsolesTypeFamilySummaryConverter,
        InsolesSummaryConverter,
        InsolesConverter,
        InsolesRepository,
        InsolesDataService,
        InsolesDataServiceAdapter,
        InsolesSummaryDataServiceAdapter
    ],
})
export class InsolesModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: InsolesRepository,
                 dataService: InsolesDataService,
    ) {

        entityDataService.registerServices({
            Insoles: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Insoles: repository,
        });

        errorMessages.set("INSOLES_SCAN_DELETION_INSOLES_WRONG_STATUS", 'Les scans ne peuvent pas être supprimés car ils sont utilisés dans une paire de semelle déjà modélisée. Supprimez d\'abord les semelles');
        errorMessages.set("INSOLES_DELETE_WRONG_STATUS", 'Le statut ne permet pas la suppression.');
        errorMessages.set("INSOLES_DELETE_NOT_PROVIDER", 'Vous devez faire partie du fournisseur pour pouvoir supprimer ces semelles.');

     }
}
